import React, { Fragment, useEffect, useState, useCallback } from 'react';
import Button from '@material-ui/core/Button';
import FormControlLabel from '@material-ui/core/FormControlLabel';
import FormControl from '@material-ui/core/FormControl';
import FormLabel from '@material-ui/core/FormLabel';
import FormHelperText from '@material-ui/core/FormHelperText';
import Checkbox from '@material-ui/core/Checkbox';
import FormGroup from '@material-ui/core/FormGroup';
import AddIcon from '@material-ui/icons/Add';
import ClientAdd from './ClientAdd';
import PreviewActionPlan from './PreviewActionPlan';
import BodyMatrix from './BodyMatrix';
import SearchInput from './../SearchInput';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { COLORS } from '../../styles/colors';
import ButtonContent from '../ButtonContent';
import LoadMoreIcon from './../LoadMoreIcon';
import Search from './../workouts/search';
import InfiniteScroll from 'react-infinite-scroll-component';
import { faTrash } from '@fortawesome/free-solid-svg-icons'
import { ConfirmJsMessage, paginationLimit } from './../../helpers.js';
import Modal from '@material-ui/core/Modal';
import ModalHeading from '../ModalHeading';
import moment from 'moment';

import _ from 'lodash';

const BodyMatrixListing = props => {
	const {
		clientEmail,
        fetchBodyMatrixRanges,
        deleteBodyMatrixRange,
        fetchBodyMatrix,
        saveBodyMatrix,
        isMobile
	} = props;

	const [rangeList, setRangeList] = useState([]);
    const [isLoadMore, setLoadMore] = useState(false);
    const [isFetchRes, setFetchRes] = useState(false);
    const [isOpenActionModal, setOpenActionModal] = useState(false);
    const [isOpenEditActionModal, setOpenEditActionModal] = useState(false);
    const [range, setRange] = useState(null);

	useEffect(() => {
	   fetchData(0)
	}, [clientEmail])

    const fetchData = (skip) => {
        fetchBodyMatrixRanges({
            clientEmail,
            skip,
            limit: paginationLimit.TWENTY,
        }).then((res) => {
            const data = Object.values(res);
            let ranges = data[0]['data']
            const metadata = data[0]['metadata']
            if (skip !== 0) {
                ranges = [...rangeList, ...ranges]
            }
            let total = 0;
            if (metadata.length && metadata[0]['total']) {
                total = metadata[0]['total'];
            }
            setFetchRes(true);
            setRangeList(ranges);
            setLoadMore(ranges.length < total)

        })

    }

    const viewActionPlan = (range) => {
        setOpenActionModal(true);
        setRange(range);
    }

    const deleteBodyMatrixRangeData = (id) => {
		if (ConfirmJsMessage(`Are you sure you want to delete this body matrix?`)) {
			deleteBodyMatrixRange(id).then(() => {
                setRangeList([])
                setFetchRes(false);
				fetchData(0)
			});
		}
	}

    const renderDate = (date) => {
        return moment(date).utc(0, true).format('MMM YYYY');
    }

    const showEditActionMode = (range) => {
        setOpenEditActionModal(true)
        setRange(range)
    }

    const onEditBodyMatrixClose = () => {
        setOpenEditActionModal(false)
    }

    const updateRange = (range) => {
        const findIndex = rangeList.findIndex((r) => r._id === range._id);
        if (findIndex > -1) {
            rangeList[findIndex] = range;
            setRangeList([...rangeList]);
        }
    }

    return (
        <Fragment>
            <div
					style={{
						marginTop: 25,
						display: 'flex',
					}}
				>
            <div style={{ marginBottom: 10, marginTop: 10 }}>
                { isOpenEditActionModal && (
                    <Modal
                    className="modal show"
                    open={isOpenEditActionModal}
                    onClose={() => { onEditBodyMatrixClose()}}
                    >
                    <div className="modalBody modal-content" style={{ width: isMobile ? '80%' : 700, minHeight: 500 }}>
                            <Fragment>
                                <ModalHeading
                                    text={ `Edit Functional Strength` }
                                    closeModal={() => { onEditBodyMatrixClose()}}
                                />
                                <div className="modalContent">
                                <BodyMatrix
                                        isEdit={true}
                                        clientEmail = {clientEmail}
                                        isOpenAddModal = { true }
                                        range = {range}
                                        parentData = { updateRange }
                                        hideActionModal = {() => {
                                            setOpenEditActionModal(false)
                                        }}
                                        isMobile = {isMobile}
                                        user = { props.user}
                                        fetchBodyMatrixMetas = { props.fetchBodyMatrixMetas}
                                        saveBodyMatrix = { saveBodyMatrix}
                                        fetchBodyMatrix = { fetchBodyMatrix }
                                        fetchBodyMatrixRanges = { props.fetchBodyMatrixRanges }
                                />
                                </div>
                            </Fragment>
                    </div>
                    </Modal>
                )}

                <div className="assign-scroll" id = "scrollableActions" style={{
                    width: isMobile ? '300px' : '800px',
                    overflow: 'auto',
					height: 350
                }}>
                            { (isFetchRes && rangeList.length === 0 ) &&
                                <div style={{ textAlign: 'center', width: isMobile ? '300px': '750px' }}>
                                   <h1>No History Available!</h1>
                                </div>
                            }

                    <InfiniteScroll
                                    dataLength={rangeList.length} //This is important field to render the next data
                                    next={() => fetchData(rangeList.length)}
                                    hasMore={isLoadMore}
                                    scrollableTarget="scrollableActions"
                                    loader={
                                        <LoadMoreIcon/>
                                    }
                            >
                            {rangeList.map(range => (
                                <Fragment>
                                    <div  style={{
                                        marginLeft: '2px',
                                    }}>
                                         <span
                                            className="link"
                                            style={{ float: 'left', width: isMobile ? '200px': '500px', display: 'block',  marginTop: '10px', marginTop: '10px' }}
                                        >{
                                            renderDate(range.startDate)
                                          }
                                         </span>
                                         <span
                                            className="link"
                                            style={{ float: 'right', marginTop: isMobile ? '5px' : '10px' }}
                                            onClick={() => deleteBodyMatrixRangeData(range._id)}
                                          >
                                            <FontAwesomeIcon icon={faTrash} title={'Delete'}
                                                size={isMobile && "2x" }
                                                style={{ marginRight: 5, color: COLORS.orange }} />
                                        </span>
                                        <span
                                            className="link"
                                            style={isMobile ? { float: 'right', marginTop: '5px', padding: '0 5px' }: { float: 'right', marginTop: '10px' }}
                                            onClick={() => showEditActionMode(range)}
                                          >
                                            <FontAwesomeIcon  icon="edit" title={'Edit Action'}
                                                size={isMobile && "2x" }
                                                style={{ marginRight: 5, color: COLORS.orange }} />
                                        </span>


                                    </div>
                                </Fragment>
                            ))}
                    </InfiniteScroll>
                </div>
            </div>
            </div>
        </Fragment>
    );
};

export default BodyMatrixListing;



// WEBPACK FOOTER //
// ./src/components/assignments/BodyMatrixListing.js